import { Button } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import * as Styled from './styles'

interface CreateFolderButtonProps {
  onClick: () => void
}

export const CreateFolderButton = ({ onClick }: CreateFolderButtonProps): ReactElement => {
  const { t } = useTranslation()

  return (
    <Styled.CreateFolderButtonWrapper>
      <Button fullWidth icon="plus" variant="outlined" onClick={onClick}>
        {t('documents.folder_view.create_folder')}
      </Button>
    </Styled.CreateFolderButtonWrapper>
  )
}
